import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { LocalStorageService } from 'src/app/core/local-storage/local-storage.service';
import { LocalStorageKeys } from 'src/app/core/local-storage/local-storage.enum';
import { LocaleEnum } from 'src/app/submit-lecture/lecture.values';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit {

  translate: TranslateService;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    translate: TranslateService,
    private localStorageService: LocalStorageService) {
    this.translate = translate;
    translate.setDefaultLang(LocaleEnum.HE);
  }

  ngOnInit(): void {
    let lang: string = this.localStorageService.read(LocalStorageKeys.language);
    lang = lang ? lang : LocaleEnum.HE;
    this.translate.setDefaultLang(lang);
    this.changeLang(lang);
  }

  changeLang(lang): void {
    this.translate.use(lang);
    this.localStorageService.write(LocalStorageKeys.language, lang);

    switch (lang) {
      case LocaleEnum.EN:
        this.document.body.classList.remove('rtl');
        this.document.body.classList.add('ltr');
        break;
      case LocaleEnum.HE:
        this.document.body.classList.remove('ltr');
        this.document.body.classList.add('rtl');
        break;
    }
  }

}
